(function(algolia) {
  'use strict';
  const render = algolia.externals.render;
  const html = algolia.externals.html;

  var algoliasearch = algolia.externals.algoliasearch;
  algolia.searchClient = algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
  );

  algolia.render = (template, container, data) => {

    return render(template(html, data), container);
  };

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(val) {
      return Number(val).toLocaleString();
    },
    buildQuickBuyClass: function buildQuickBuyClass(data){

      var classList = '';

      if (data.available){
          var classList = 'product-quick_buy_option';
      } else {
          var classList = 'product-quick_buy_option quick_buy_option_disabled';
      }


      return classList;
    },
    OnSale: function OnSale(data){
      var class_sale = ''
      var onSale = data.compare_at_price > data.price;
      if (onSale){
        class_sale = 'sale'
      }
      return class_sale;
    },

    getVariants: async function getVariants(productId) {

      return new Promise(function (resolve, reject) {
        if (!productId) {
          reject(new Error("No productId provided"));
          return;
        }

        var url_2 = `${window.location.origin}/products/${productId}.js`;

        $.ajax({
          method: "GET",
          url: url_2,
          headers: {
            'Content-Type': 'application/json'
          },
          success: function (data) {
            resolve(JSON.parse(data));
          },
          error: function (error) {
            console.error("Error fetching product", error);
            reject(error);
          }
        });
      });

        // end test code


      //   const url = `${window.location.origin}/admin/api/2023-07/products/${productId}.json`;


      //   try {
      //     const response = await fetch(url, {
      //       headers: {
      //         'X-Shopify-Access-Token': `${window.theme.api_algolia}`,
      //       },
      //     });

      //     if (!response.ok) {
      //       throw new Error('Failed to fetch product');
      //     }

      //     const data = await response.json();
      //     return data.product;
      //   } catch (error) {
      //     console.error(error);
      //     throw new Error('Failed to fetch product');
      //   }
      // }
    },

    displayPrice: function displayPrice(item, distinct) {

      if (distinct) {
        var min = item.variants_min_price;
        var max = item.variants_max_price;
        if (min !== max) {
          return  formatPrice(min) + ' - ' + formatPrice(max);
        }
      }
      return formatPrice(item.price);
    },
    displayStrikedPrice: function displayStrikedPrice(price, compare_at_price) {
      const comparing =
        Number(compare_at_price) && Number(compare_at_price) > Number(price);
      if (comparing) { return formatPrice(compare_at_price) }
    },
    // Card price parts, mirroring snippets/card-price.liquid. Sizes priced
    // differently show the price range, with the full RRP range struck when the
    // whole colour is marked down, so it never depends on which variant record
    // the current sort returned. Pure, so safe to call from item() on every re-render.
    cardPrice: function cardPrice(item, distinct) {
      var price = Number(item.price);
      var compare = Number(item.compare_at_price);
      var min = Number(item.variants_min_price);
      var max = Number(item.variants_max_price);

      if (distinct && min && max && min !== max) {
        // The compare-at aggregates span every size, but Algolia doesn't say
        // which sizes are marked down. A whole-colour markdown shows as the
        // returned record's markdown ratio landing on both ends of the price
        // range (to the cent, allowing for rounding); anything else is partial,
        // so the range shows without a strike.
        var compareMin = Number(item.variants_compare_at_price_min);
        var compareMax = Number(item.variants_compare_at_price_max);
        var ratio = compare > price ? price / compare : 0;
        var wholeMarkdown = ratio > 0 && compareMin && compareMax &&
          Math.abs(compareMin * ratio - min) < 0.05 &&
          Math.abs(compareMax * ratio - max) < 0.05;
        return {
          price: formatPrice(min) + ' - ' + formatPrice(max),
          compare: wholeMarkdown ? formatPrice(compareMin) + ' - ' + formatPrice(compareMax) : null,
          onSale: wholeMarkdown || compare > price,
        };
      }

      return {
        price: formatPrice(price),
        compare: compare > price ? formatPrice(compare) : null,
        onSale: compare > price,
      };
    },
    displayDiscount: function displayDiscount(price, compare_at_price, price_ratio) {
      const comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
      const discount_ratio = 1.0 - price_ratio;
      if (comparing) { return `- ${Math.floor(discount_ratio * 100)} %`}
    },
    instantsearchLink: function instantsearchLink(hit) {
      const addVariantId = !hit._distinct && hit.objectID !== hit.id;
      return (
        '/products/' +
        hit.handle +
        (addVariantId ? '?variant=' + hit.objectID : '')
      );
    },
    fullTitle: function fullTitle(title, distinct, variant_title) {
      var res = title;
      if (
        !distinct &&
        variant_title &&
        variant_title !== 'Default Title' &&
        variant_title !== 'Default'
      ) {
        res += ' (' + variant_title + ')';
      }

      return (res);
    },
    variantTitleAddition: function variantTitleAddition(item, distinct) {
      var res = ' ';
      if (
        !distinct &&
        item.variant_title &&
        item.variant_title !== 'Default Title' &&
        item.variant_title !== 'Default'
      ) {
        res += `( ${item.variant_title} )`;
      }
      return res;
    },
    hexToRGB: function hexToRGB(hex){
      if (!hex) return ``;
      if(hex.length== 4){
        hex = hex.substring(1).replace(/./g, '$&$&')
      }
      var m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
      return `${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)}`;
    },
    sizedImage: function sizedImage(sizeInput, item, _distinct) {
      var image = _distinct ? item.product_image : item.image;
      if (!image) {
        return `https:`+ `${window.placeholderImageURL}`;
      }
      var size = sizeInput.replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    }


  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original'
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = function(item) {
        var image = item.distinct ? item.product_image : item.image;

        if (!image) {
          const placeholderImageURL = window.placeholderImageURL;

          return `https:`+ `${placeholderImageURL}`;
        }

        if (size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    };
  });
})(window.algoliaShopify);
